jQuery(document).ready(function($) {
    var points = 0;
    var qIndex = 1;
    $("#startQuiz").click(function (e) {
        e.preventDefault();
        $('#quizIntro').fadeOut(
            function(){
                $("#quiz").fadeIn(500);
            }
        );
    });
    $('#quiz input[type="radio"]').change(function(){
        var val = $(this).val()
        $('#q'+qIndex+' > label').addClass('disabled');
        $('#q'+qIndex+' > label').css({"color": "#ccc", "border-color": "#ccc"});
        if(val == 1){
            $(this).next('label').css({"color": "green", "border-color": "green"});
            points++
        } else if (val == 0){
            $(this).next('label').css({"color": "red", "border-color": "red"});
            var correct = $('#q'+qIndex).find("[value='1']");
            var correctAnswer = correct.next('label').text();
            $('#rightAnswerTxt').text(correctAnswer);
            $('#rightAnswer').fadeIn();
        }
        $('input[name=q'+qIndex+']').attr("disabled",true);
        if(qIndex == 7){
            $('#seeResults').fadeIn(400);
        } else {
            $('#nextBtn').fadeIn(400);
        }
    });
    $('#nextBtn').click(function(e){
        e.preventDefault();
        var curIndex = qIndex;
        qIndex++;
        $('#quiz-pager-counter').text(qIndex);
        $('#q'+curIndex+'').fadeOut(
            function(){
                $('#q'+qIndex+'').fadeIn(500);
            }
        );
        $(this).hide();
        $('#rightAnswer').hide();
    });
    $('#seeResults').click(function(e){
        e.preventDefault();
        $('#quiz-pager').fadeOut(400);
        $('#q7').fadeOut(400,
            function(){
                $('#quizResults').fadeIn(400);
                checkPoints();
            }
        );
        $(this).hide();
        $('#rightAnswer').hide();
    });
    function checkPoints(){
        $('#totalpoints').text(points);
        if(points < 5) {
            $('#rank3').show();
        }
        else if(points > 4 && points < 7) {
            $('#rank2').show();
        }else if(points > 6) {
            $('#rank1').show();
        }
    }
});